module.exports = __webpack_public_path__ + "static/media/price-tag.1f2b59b0.svg";